"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataType;
(function (DataType) {
    DataType["STRING"] = "string";
    DataType["NUMBER"] = "number";
    DataType["DATE"] = "date";
    DataType["DATETIME"] = "datetime";
    DataType["TIME"] = "time";
    DataType["TIMESTAMP"] = "timestamp";
    DataType["TIMEWITHTIMEZONE"] = "timeWithTimeZone";
    DataType["TIMESTAMPWITHTIMEZONE"] = "timestampWithTimeZone";
    DataType["BINARY"] = "binary";
})(DataType || (DataType = {}));
exports.default = DataType;
//# sourceMappingURL=DataType.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/interfaces/DataType.js
// module id = 220
// module chunks = 8